/**
 * DENEB London Theme - Product Page
 *
 * Extracted from sections/product.liquid (Task 20b) so the bulk of the
 * product page JS can be cached as a static asset instead of re-sent
 * inline on every product page view.
 *
 * This script has no Liquid interpolations: all dynamic data is read from
 * the DOM at runtime — the variant list comes from the
 * <script type="application/json" id="product-variants-json"> element
 * rendered by the section, and per-image data comes from data-* attributes.
 *
 * Globals relied upon (defined elsewhere, intentionally not duplicated):
 *   - window.openCartDrawer() -> sections/cart-drawer.liquid (guarded with typeof)
 *
 * Globals exposed for inline onclick= handlers in the section markup:
 *   - window.openImageLightbox, window.closeImageLightbox
 *   - window.lightboxPrev, window.lightboxNext
 *
 * Editor-safe init: initialises once on normal page load, and re-initialises
 * against fresh DOM on shopify:section:load.
 */
(function () {
  // ── Module-scope lightbox state (shared by the global lightbox fns) ────
  var currentLightboxIndex = 0;
  var filteredImages = [];

  // ── Module-scope cart state for inventory tracking ──────────────────────────
  var currentCart = null;

  // ── Module-scope focus-return state ─────────────────────────────────────
  var lastFocusedLightbox = null;
  var lastFocusedPopup = null;

  function getVisibleImages() {
    // Get only visible thumbnails (filtered by current variant)
    const thumbnails = document.querySelectorAll('.product-page__thumbnail');
    const images = [];

    // First add the main image
    const mainImage = document.getElementById('product-main-image');
    if (mainImage) {
      images.push({
        url: mainImage.dataset.zoomUrl || mainImage.src.replace('width=1200', 'width=2000'),
        alt: mainImage.alt,
      });
    }

    // Then add visible thumbnails
    thumbnails.forEach((thumb) => {
      if (thumb.style.display !== 'none') {
        images.push({
          url: thumb.dataset.imageUrl.replace('width=1200', 'width=2000'),
          alt: thumb.dataset.imageAlt,
        });
      }
    });

    return images;
  }

  function openImageLightbox(imgElement) {
    const lightbox = document.getElementById('image-lightbox');
    const lightboxImg = document.getElementById('lightbox-image');

    // Build filtered image array based on current variant selection
    filteredImages = getVisibleImages();

    // Get high-res URL (either from data attribute or modify current src)
    let highResUrl = imgElement.dataset.zoomUrl || imgElement.dataset.imageUrl;
    if (!highResUrl) {
      highResUrl = imgElement.src.replace('width=400', 'width=2000').replace('width=1200', 'width=2000');
    } else {
      highResUrl = highResUrl.replace('width=1200', 'width=2000');
    }

    lightboxImg.src = highResUrl;
    lightboxImg.alt = imgElement.alt;

    // Find current index in filtered images
    currentLightboxIndex = filteredImages.findIndex((img) => img.url === highResUrl);
    if (currentLightboxIndex === -1) currentLightboxIndex = 0;

    lastFocusedLightbox = document.activeElement;
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    // Move focus into the lightbox
    var lightboxClose = lightbox.querySelector('.image-lightbox__close');
    if (lightboxClose) lightboxClose.focus();

    // Add keyboard listener
    document.addEventListener('keydown', lightboxKeyHandler);
  }

  function closeImageLightbox() {
    const lightbox = document.getElementById('image-lightbox');
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', lightboxKeyHandler);
    if (lastFocusedLightbox && document.contains(lastFocusedLightbox)) {
      lastFocusedLightbox.focus();
    }
    lastFocusedLightbox = null;
  }

  function lightboxPrev() {
    if (filteredImages.length === 0) return;
    currentLightboxIndex = (currentLightboxIndex - 1 + filteredImages.length) % filteredImages.length;
    updateLightboxImage();
  }

  function lightboxNext() {
    if (filteredImages.length === 0) return;
    currentLightboxIndex = (currentLightboxIndex + 1) % filteredImages.length;
    updateLightboxImage();
  }

  function updateLightboxImage() {
    const lightboxImg = document.getElementById('lightbox-image');
    if (filteredImages[currentLightboxIndex]) {
      lightboxImg.src = filteredImages[currentLightboxIndex].url;
      lightboxImg.alt = filteredImages[currentLightboxIndex].alt;
    }
  }

  function lightboxKeyHandler(e) {
    if (e.key === 'Escape') closeImageLightbox();
    if (e.key === 'ArrowLeft') lightboxPrev();
    if (e.key === 'ArrowRight') lightboxNext();
  }

  // Expose functions referenced by inline onclick= handlers in the markup.
  window.openImageLightbox = openImageLightbox;
  window.closeImageLightbox = closeImageLightbox;
  window.lightboxPrev = lightboxPrev;
  window.lightboxNext = lightboxNext;

  function initProduct() {
    const productPage = document.querySelector('.product-page');
    if (!productPage) return;

    // Guard against double-init against the same DOM.
    if (document.body && document.body.dataset.productJsInit === 'true') return;
    if (document.body) document.body.dataset.productJsInit = 'true';

    // Thumbnail gallery
    const mainImage = document.getElementById('product-main-image');
    const thumbnails = document.querySelectorAll('.product-page__thumbnail');
    const scrollGallery = document.querySelector('.product-page__scroll-gallery');

    // Thumbnails are for display only - clicking opens lightbox instead
    thumbnails.forEach((thumb) => {
      thumb.addEventListener('click', function () {
        // Open lightbox with this thumbnail image
        const img = this.querySelector('img');
        if (img) {
          openImageLightbox(img);
        }
      });
    });

    // Image navigation buttons - open lightbox
    const prevBtn = document.querySelector('.product-page__nav-btn--prev');
    const nextBtn = document.querySelector('.product-page__nav-btn--next');

    if (prevBtn) prevBtn.addEventListener('click', () => openImageLightbox(mainImage));
    if (nextBtn) nextBtn.addEventListener('click', () => openImageLightbox(mainImage));

    // Variant data + option-based selection
    const variantInput = document.getElementById('product-variant-id');
    const priceEl = document.getElementById('product-price');
    const addToCartBtn = document.querySelector('.product-page__add-to-cart');
    const quantityInput = document.getElementById('product-quantity');
    const quantityControls = document.querySelector('.product-page__quantity-controls');

    const variantsJsonEl = document.getElementById('product-variants-json');
    const allVariants = variantsJsonEl ? JSON.parse(variantsJsonEl.textContent) : [];

    // Track currently selected value per option index
    const selectedOptions = [];
    document.querySelectorAll('.product-page__variants[data-option-index]').forEach((group) => {
      const active = group.querySelector('.product-page__swatch.is-active');
      if (active) {
        selectedOptions[parseInt(group.dataset.optionIndex)] = active.dataset.optionValue;
      }
    });

    function findMatchingVariant() {
      return allVariants.find((v) =>
        v.options.every((opt, i) => !selectedOptions[i] || selectedOptions[i] === opt)
      );
    }

    function filterImagesByVariant(finishValue, hideMainImage = false) {
      const variantSlug = finishValue.toLowerCase().replace(/\s+/g, '-');
      let firstMatch = null;

      const variantAliases = {
        'white-gold': ['white-gold'],
        'sterling-silver': ['sterling-silver'],
        'yellow-gold': ['yellow-gold'],
        'rose-gold': ['rose-gold'],
      };
      const acceptedTags = variantAliases[variantSlug] || [variantSlug];

      // First pass: show/hide thumbnails and find the first match for the main image
      thumbnails.forEach((thumb) => {
        const thumbVariant = thumb.dataset.variant;
        if (thumbVariant && acceptedTags.includes(thumbVariant)) {
          thumb.style.display = '';
          if (!firstMatch) firstMatch = thumb;
        } else {
          thumb.style.display = 'none';
          thumb.classList.remove('is-active');
        }
      });

      if (firstMatch) {
        mainImage.src = firstMatch.dataset.imageUrl;
        mainImage.srcset = '';
        mainImage.alt = firstMatch.dataset.imageAlt;
        mainImage.dataset.zoomUrl = firstMatch.dataset.imageUrl.replace('width=1200', 'width=2000');

        // Hide the thumbnail that's now the main image
        firstMatch.style.display = 'none';

        const visibleThumbs = Array.from(thumbnails).filter((t) => t.style.display !== 'none');
        if (visibleThumbs.length > 0 && scrollGallery) {
          visibleThumbs[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }

      // The mobile swipe gallery (.product-page__mobile-slide + .product-page__dot)
      // is a SEPARATE DOM from the desktop thumbnails, so it must be filtered here
      // too — otherwise selecting a finish leaves every image showing on mobile.
      // Safety: if no slide matches the finish (e.g. untagged images), show them
      // all rather than strand the gallery empty.
      const mobileSlides = document.querySelectorAll('.product-page__mobile-slide');
      if (mobileSlides.length) {
        const mobileDots = document.querySelectorAll('.product-page__dot');
        const matchesFinish = (el) => el.dataset.variant && acceptedTags.includes(el.dataset.variant);
        const anyMatch = Array.from(mobileSlides).some(matchesFinish);
        mobileSlides.forEach((slide) => {
          slide.style.display = !anyMatch || matchesFinish(slide) ? '' : 'none';
        });
        mobileDots.forEach((dot) => {
          dot.style.display = !anyMatch || matchesFinish(dot) ? '' : 'none';
        });
        const imagesWrapper = document.querySelector('.product-page__images-wrapper');
        if (imagesWrapper) imagesWrapper.scrollLeft = 0;
      }
    }

    function applyVariant(variant, filterImages, hideMainImage) {
      if (!variant) return;

      variantInput.value = variant.id;

      const currentPriceSpan = priceEl.querySelector('[data-current-price]');
      const comparePriceSpan = priceEl.querySelector('[data-compare-price]');
      const saleBadge = priceEl.querySelector('.sale-badge');
      const priceWrapper = priceEl.querySelector('.price');

      if (currentPriceSpan) currentPriceSpan.textContent = variant.price;

      if (variant.compareAtPrice) {
        if (comparePriceSpan) {
          comparePriceSpan.textContent = variant.compareAtPrice;
        } else {
          const newCompareSpan = document.createElement('span');
          newCompareSpan.className = 'price__compare';
          newCompareSpan.setAttribute('data-compare-price', '');
          newCompareSpan.textContent = variant.compareAtPrice;
          if (currentPriceSpan && currentPriceSpan.parentNode) {
            currentPriceSpan.parentNode.insertBefore(newCompareSpan, currentPriceSpan);
          }
        }
        if (!saleBadge) {
          const newBadge = document.createElement('span');
          newBadge.className = 'sale-badge';
          newBadge.textContent = 'Sale';
          priceEl.insertBefore(newBadge, priceEl.querySelector('.price'));
        }
        if (priceWrapper) priceWrapper.classList.add('price--on-sale');
      } else {
        if (comparePriceSpan) comparePriceSpan.remove();
        if (saleBadge) saleBadge.remove();
        if (priceWrapper) priceWrapper.classList.remove('price--on-sale');
      }

      // Check available quantity to add taking current cart into account
      const isTracked = variant.inventory_management === 'shopify';
      const denyOversell = variant.inventory_policy === 'deny';
      let qtyAvailableToAdd = variant.inventory || 0;

      if (isTracked && denyOversell) {
        const cartItem = (currentCart && currentCart.items)
          ? currentCart.items.find(item => item.variant_id === variant.id || item.id === variant.id)
          : null;
        const qtyInCart = cartItem ? cartItem.quantity : 0;
        qtyAvailableToAdd = Math.max(0, (variant.inventory || 0) - qtyInCart);
      }

      const isActuallyAvailable = variant.available && qtyAvailableToAdd > 0;

      addToCartBtn.disabled = !isActuallyAvailable;
      addToCartBtn.textContent = isActuallyAvailable ? 'Add to Bag' : 'Sold Out';

      if (quantityInput) {
        if (isActuallyAvailable) {
          quantityInput.max = qtyAvailableToAdd;
          if (parseInt(quantityInput.value) > qtyAvailableToAdd) {
            quantityInput.value = qtyAvailableToAdd;
          }
          quantityInput.disabled = false;
        } else {
          quantityInput.max = 0;
          quantityInput.value = 1;
          quantityInput.disabled = true;
        }
        updateQuantityButtonStates();
      }

      const stickyPrice = document.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = variant.price;

      const stickyBtn = document.getElementById('sticky-add-btn');
      if (stickyBtn) {
        stickyBtn.disabled = !isActuallyAvailable;
        stickyBtn.textContent = isActuallyAvailable ? 'Add to Bag' : 'Sold Out';
      }

      // Update Finance Installment Values
      const split3El = document.querySelector('[data-finance-split-3]');
      const split4El = document.querySelector('[data-finance-split-4]');
      
      if (variant && (split3El || split4El)) {
        var formatFn = (window.theme && window.theme.formatMoney) || function(cents) {
          return '£' + (cents / 100).toFixed(2);
        };
        var priceCents = variant.price_raw;
        if (!priceCents && variant.price) {
          priceCents = parseInt(variant.price.replace(/[^0-9]/g, ''), 10);
        }
        if (priceCents) {
          if (split3El) {
            split3El.textContent = formatFn(Math.round(priceCents / 3));
          }
          if (split4El) {
            split4El.textContent = formatFn(Math.round(priceCents / 4));
          }
        }
      }
      if (filterImages) {
        filterImagesByVariant(selectedOptions[0] || variant.options[0], hideMainImage);
      }
    }

    // Delegate clicks on all option groups
    document.querySelectorAll('.product-page__variants[data-option-index]').forEach((group) => {
      group.addEventListener('click', function (e) {
        const swatch = e.target.closest('.product-page__swatch');
        if (!swatch) return;

        const optionIndex = parseInt(swatch.dataset.optionIndex);
        const optionValue = swatch.dataset.optionValue;

        // Update active state within this group only
        group.querySelectorAll('.product-page__swatch').forEach((s) => {
          s.classList.remove('is-active');
          s.setAttribute('aria-pressed', 'false');
        });
        swatch.classList.add('is-active');
        swatch.setAttribute('aria-pressed', 'true');

        selectedOptions[optionIndex] = optionValue;
        const variant = findMatchingVariant();
        // Only filter images when the finish (option 0) changes
        applyVariant(variant, optionIndex === 0, true);
      });
    });

    // Initial variant setup on page load
    const initialVariant = findMatchingVariant();
    if (initialVariant) {
      applyVariant(initialVariant, true, false);
    } else if (selectedOptions[0]) {
      // Fallback: even if no variant matched, still filter images by the selected finish
      filterImagesByVariant(selectedOptions[0], false);
    }

    // Ring size guide link: open the accordion and scroll to it
    const sizeGuideLink = document.querySelector('[data-size-guide-link]');
    if (sizeGuideLink) {
      sizeGuideLink.addEventListener('click', function (e) {
        const guide = document.getElementById('ring-size-guide');
        if (!guide) return;
        e.preventDefault();
        guide.open = true;
        guide.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    // Quantity controls — use event delegation on the container
    // Use event delegation for quantity buttons
    if (quantityControls) {
      quantityControls.addEventListener('click', function (e) {
        const btn = e.target.closest('.product-page__quantity-btn');
        if (!btn) return;

        let value = parseInt(quantityInput.value) || 1;
        const max = parseInt(quantityInput.max) || Infinity;
        if (btn.dataset.action === 'increase' && value < max) {
          quantityInput.value = value + 1;
          updateQuantityButtonStates();
        } else if (btn.dataset.action === 'decrease' && value > 1) {
          quantityInput.value = value - 1;
          updateQuantityButtonStates();
        }
      });
    }

    // Update quantity button states
    function updateQuantityButtonStates() {
      if (!quantityControls) return;
      const increaseBtn = quantityControls.querySelector('[data-action="increase"]');
      const decreaseBtn = quantityControls.querySelector('[data-action="decrease"]');
      const currentValue = parseInt(quantityInput.value) || 1;
      const maxValue = quantityInput.max !== "" ? parseInt(quantityInput.max) : Infinity;

      const isSoldOut = maxValue <= 0;

      if (increaseBtn) {
        increaseBtn.disabled = isSoldOut || currentValue >= maxValue;
        increaseBtn.style.opacity = (isSoldOut || currentValue >= maxValue) ? '0.5' : '1';
        increaseBtn.style.cursor = (isSoldOut || currentValue >= maxValue) ? 'not-allowed' : 'pointer';
      }
      if (decreaseBtn) {
        decreaseBtn.disabled = isSoldOut || currentValue <= 1;
        decreaseBtn.style.opacity = (isSoldOut || currentValue <= 1) ? '0.5' : '1';
        decreaseBtn.style.cursor = (isSoldOut || currentValue <= 1) ? 'not-allowed' : 'pointer';
      }
    }

    // Initialize button states
    updateQuantityButtonStates();

    // Popups
    const popupTriggers = document.querySelectorAll('[data-popup]');

    popupTriggers.forEach((trigger) => {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        const popupId = this.dataset.popup + '-popup';
        const popup = document.getElementById(popupId);
        if (popup) {
          lastFocusedPopup = document.activeElement;
          popup.classList.add('is-open');
          popup.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
          var closeBtn = popup.querySelector('.product-popup__close');
          if (closeBtn) closeBtn.focus();
        }
      });
    });

    document.querySelectorAll('.product-popup__backdrop, .product-popup__close').forEach((el) => {
      el.addEventListener('click', function () {
        const popup = this.closest('.product-popup');
        popup.classList.remove('is-open');
        popup.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        if (lastFocusedPopup && document.contains(lastFocusedPopup)) {
          lastFocusedPopup.focus();
        }
        lastFocusedPopup = null;
      });
    });

    // AJAX Add to Cart
    const productForm = document.getElementById('product-form');
    if (productForm) {
      productForm.addEventListener('submit', function (e) {
        e.preventDefault();

        // Intercept and verify quantity before sending request
        const variant = findMatchingVariant();
        if (variant) {
          const isTracked = variant.inventory_management === 'shopify';
          const denyOversell = variant.inventory_policy === 'deny';
          if (isTracked && denyOversell) {
            const cartItem = (currentCart && currentCart.items)
              ? currentCart.items.find(item => item.variant_id === variant.id || item.id === variant.id)
              : null;
            const qtyInCart = cartItem ? cartItem.quantity : 0;
            const qtyAvailableToAdd = Math.max(0, (variant.inventory || 0) - qtyInCart);
            const requestedQuantity = parseInt(quantityInput.value) || 1;

            if (qtyAvailableToAdd <= 0 || requestedQuantity > qtyAvailableToAdd) {
              alert("Sorry, we only have " + qtyAvailableToAdd + " available in stock (taking into account items already in your bag).");
              return;
            }
          }
        }

        const formData = new FormData(this);
        const addBtn = this.querySelector('.product-page__add-to-cart');
        const originalText = addBtn.textContent;
        addBtn.textContent = 'Adding...';
        addBtn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
        })
          .then((response) =>
            response.json().then((data) => {
              if (!response.ok) {
                throw new Error(data.description || data.message || 'Could not add to bag');
              }
              return data;
            })
          )
          .then(() => {
            addBtn.textContent = originalText;
            addBtn.disabled = false;
            
            // Dispatch custom cart:updated event to sync all page segments
            document.dispatchEvent(new CustomEvent('cart:updated'));

            if (typeof window.openCartDrawer === 'function') {
              window.openCartDrawer();
            } else {
              fetch('/cart.js')
                .then((res) => res.json())
                .then((cart) => {
                  document.querySelectorAll('.header__cart-count').forEach((el) => {
                    el.textContent = cart.item_count;
                    el.style.display = cart.item_count > 0 ? 'flex' : 'none';
                  });
                })
                .catch((error) => console.error('Error fetching cart:', error));
            }
          })
          .catch((error) => {
            addBtn.textContent = error.message || 'Could not add to bag';
            addBtn.disabled = false;
            setTimeout(() => {
              addBtn.textContent = originalText;
            }, 3000);
          });
      });
    }

    // Sticky Add to Bag Bar
    const stickyBar = document.getElementById('sticky-add-bar');
    const stickyBtn = document.getElementById('sticky-add-btn');
    const addToCartButton = document.getElementById('product-add-to-cart');

    if (stickyBar && addToCartButton) {
      // Use IntersectionObserver to detect when main Add to Bag button leaves viewport
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // Main button is visible - hide sticky bar
              stickyBar.classList.remove('is-visible');
              stickyBar.setAttribute('aria-hidden', 'true');
            } else {
              // Main button is out of view - show sticky bar
              stickyBar.classList.add('is-visible');
              stickyBar.setAttribute('aria-hidden', 'false');
            }
          });
        },
        {
          threshold: 0,
          rootMargin: '0px',
        }
      );

      observer.observe(addToCartButton);

      // Sticky bar click triggers the main form submit
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          if (this.disabled) return;
          const form = document.getElementById('product-form');
          if (form) {
            form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          }
        });
      }
    }

    // Mobile swipe gallery dot sync
    (function () {
      if (window.innerWidth > 900) return;
      var wrapper = document.querySelector('.product-page__images-wrapper');
      var dots = document.querySelectorAll('.product-page__dot');
      var slides = document.querySelectorAll('.product-page__mobile-slide');
      if (!wrapper || dots.length === 0 || slides.length === 0) return;

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var idx = parseInt(entry.target.getAttribute('data-slide-index'), 10);
            dots.forEach(function (d, i) {
              d.classList.toggle('is-active', i === idx);
            });
          }
        });
      }, { root: wrapper, threshold: 0.6 });

      slides.forEach(function (slide) { observer.observe(slide); });

      // Tap dot to scroll to slide
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var idx = parseInt(this.getAttribute('data-dot-index'), 10);
          if (slides[idx]) {
            slides[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          }
        });
      });
    })();

    // Fetch cart on load to initialize inventory limits
    fetch('/cart.js')
      .then((res) => res.json())
      .then((cart) => {
        currentCart = cart;
        const variant = findMatchingVariant();
        if (variant) {
          applyVariant(variant, false, false);
        }
      })
      .catch((error) => console.error('Error loading cart data:', error));

    // Listen for cart:updated event to synchronize stock levels
    document.addEventListener('cart:updated', function () {
      fetch('/cart.js')
        .then((res) => res.json())
        .then((cart) => {
          currentCart = cart;
          const variant = findMatchingVariant();
          if (variant) {
            applyVariant(variant, false, false);
          }
        })
        .catch((error) => console.error('Error synchronizing cart data:', error));
    });

    // Enforce manual quantity selector change limit check
    if (quantityInput) {
      quantityInput.addEventListener('change', function () {
        const variant = findMatchingVariant();
        if (!variant) return;

        let value = parseInt(this.value) || 1;
        
        // Calculate remaining available stock
        const isTracked = variant.inventory_management === 'shopify';
        const denyOversell = variant.inventory_policy === 'deny';
        let qtyAvailableToAdd = variant.inventory || 0;

        if (isTracked && denyOversell) {
          const cartItem = (currentCart && currentCart.items)
            ? currentCart.items.find(item => item.variant_id === variant.id || item.id === variant.id)
            : null;
          const qtyInCart = cartItem ? cartItem.quantity : 0;
          qtyAvailableToAdd = Math.max(0, (variant.inventory || 0) - qtyInCart);
        }

        if (value < 1) {
          this.value = 1;
          value = 1;
        }

        if (value > qtyAvailableToAdd) {
          alert("Sorry, we only have " + qtyAvailableToAdd + " available in stock (taking into account items already in your bag).");
          this.value = qtyAvailableToAdd || 1;
          value = qtyAvailableToAdd || 1;
        }
        updateQuantityButtonStates();
      });
    }
  }

  // ── Module-scope Escape handler for product popups ───────────────────────
  // Bound once at IIFE level so it is never duplicated on section re-init.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    const openPopup = document.querySelector('.product-popup.is-open');
    if (!openPopup) return;
    openPopup.classList.remove('is-open');
    openPopup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocusedPopup && document.contains(lastFocusedPopup)) {
      lastFocusedPopup.focus();
    }
    lastFocusedPopup = null;
  });

  // Run on DOMContentLoaded or immediately if already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProduct);
  } else {
    initProduct();
  }

  // Re-init against fresh DOM when the section is reloaded in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.product-page')) {
      if (document.body) document.body.dataset.productJsInit = '';
      initProduct();
    }
  });
})();
